import {  Flex, Radio, Tooltip } from "antd";
import React, { useState } from "react";
import { CustomParagraph } from "../../../components";
import optionsIcon from "../../../assets/images/options2.svg";
import settingsIcon from "../../../assets/images/settings.svg";
import { useSelector } from "react-redux";
import { useToken } from "../../../common/helper";
import { useNavigate } from "react-router-dom";
import AlertFilterDropdown from "./AlertFilterDropdown";

const AnalyticsChartData = ({
  title,
  data,
  value,
  change,
  fromDate,
  setModalOpen,
  setSelectedMetricData,
  isShipments,
  handleTabChange,
  setOpenBufferModal,
  handleRFTAlertsApply,
}) => {
  const { token, removeToken } = useToken();
  const navigate = useNavigate();

  const unauthorize = (error) => {
    if (error && error?.status === 401) {
      removeToken();
      navigate("/login");
    }
  };

  const getContentKeyByTitle = (title) => {
    switch (title) {
      case "Shipments":
        return "shipments";

      case "On-time delivery (OTD)":
        return "otd";

      case "Transit time":
        return "transit";

      case "Right first-time (RFT)":
        return "rft";

      default:
        return null;
    }
  };
  const contentKey = getContentKeyByTitle(title);

  function getFormattedChange(variance) {
    if (variance === null || variance === undefined || variance === "") return "";
  
    let isPercent = false;
    let strValue = String(variance).trim();
  
    if (strValue.includes("%")) {
      isPercent = true;
      strValue = strValue.replace("%", "");
    }
  
    const num = parseFloat(strValue);
    if (isNaN(num)) return variance;
  
    const absValue = Math.abs(num);
    const isUp = num > 0;
    const color = isUp ? "#0E8345" : "#DE1135";
  
    const arrowPath = isUp
      ? "M2 6L2.705 6.705L5.5 3.915V10H6.5V3.915L9.29 6.71L10 6L6 2L2 6Z"
      : "M10 6L9.295 5.295L6.5 8.085V2H5.5V8.085L2.71 5.29L2 6L6 10L10 6Z";
  
    return (
      <span style={{ display: "flex", alignItems: "center", gap: "2px" }}>
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
          <path d={arrowPath} fill={color} />
        </svg>
        {absValue}
        {isPercent && "%"}
      </span>
    );
  }
  
  

  const getChangeColor = (value) => {
    if (value === null || value === undefined || value === "") return "#5E5E5E";

    const num = parseFloat(String(value).replace("%", "").trim());
    if (isNaN(num)) return "#5E5E5E";

    return num >= 0 ? "#0E8345" : "#DE1135";
  };

  const mainMenu = useSelector((state) => state.menu.items);
  const homePermissions = mainMenu?.find(
    (item) => item?.name.toLowerCase() == "home"
  );
const [values, setValues] = useState(() => 
  title === "Transit time" ? "Median" : "Delivered"
);

  return (
    <>
      <Flex gap={8} align="center" justify="space-between">
        {title !=='Right first-time (RFT)' &&
        <CustomParagraph
          text={title}
          fontSize={14}
          fontWeight={600}
          lineHeight={"16px"}
          marginBottom={5}
          color={"#000"}
          style={{
            borderBottom: title =='Right first-time (RFT)' ? "1px dotted #000" : 0,
            display: "inline-block",
          }}
        />
}
        {title =='Right first-time (RFT)' && 
         <Tooltip
                      title={
                        <div
                          style={{
                            textAlign: "center",
                            whiteSpace: "normal",
                            fontSize: "12px",
                            fontWeight: "500",
                            lineHeight: "16px",
                          }}
                        >
                         RFT = shipment on time and with no alert(s)
                        </div>
                      }
                      overlayStyle={{ maxWidth: "154px", textAlign: "center" }}
                      placement="top"
                    >
                         
<span>

        <CustomParagraph
          text={title}
          fontSize={14}
          fontWeight={600}
          lineHeight={"16px"}
          marginBottom={5}
          color={"#000"}
          style={{
            borderBottom: title =='Right first-time (RFT)' ? "1px dotted #000" : 0,
            display: "inline-block",
          }}
          />
          </span>
          </Tooltip>}
        <Flex gap={18} align="center">
          {contentKey === "shipments" || contentKey === "transit" ? (
            <Radio.Group
              value={values}
              onChange={(e) => {setValues(e.target.value);handleTabChange(contentKey=='shipments' ? 'shipments' : 'transit' , e.target.value)}}
              style={{
                borderRadius: 4,
                overflow: "hidden",
                // border: "1px solid #d9d9d9",
              }}
              size="small"
              className="home-radio-group"
            >
              {(title === "Transit time"
                ? ["Median", "Avg"]
                : ["Delivered", "Status", "Timeliness", "Risk"]
              ).map((item) => (
                <Radio.Button
                  key={item}
                  value={item}
                  style={{
                    fontWeight: 400,
                    fontSize: 12,
                    padding: "1px 8px",
                    backgroundColor: values === item ? "#000" : "#fff",
                    color: values === item ? "#fff" : "#000",
                    borderColor: values === item ? "#000" : "#d9d9d9",
                    // borderRadius: 0,
                  }}
                >
                  {item.charAt(0).toUpperCase() + item.slice(1)}
                </Radio.Button>
              ))}
            </Radio.Group>
          ) : null}

{homePermissions?.permissions?.is_create ||
          homePermissions?.permissions?.is_update ? (
            <>

{contentKey=='otd' && 
  <img
  onClick={() => {
    setOpenBufferModal(true);
    setSelectedMetricData({ ...data, title });
  }}
  src={settingsIcon}
  alt=""
  className="cursor-pointer"
/>}
</>
          ) : null}
{contentKey=='rft' && 

<AlertFilterDropdown handleRFTAlertsApply={handleRFTAlertsApply}/>
}
          {homePermissions?.permissions?.is_create ||
          homePermissions?.permissions?.is_update ? (
            <>
              {isShipments?.length > 0 && (
                <Tooltip placement="top" title={"Add/edit target"} arrow={true}>
                  <img
                    onClick={() => {
                      setModalOpen(true);
                      setSelectedMetricData({ ...data, title });
                    }}
                    src={optionsIcon}
                    alt=""
                    className="cursor-pointer"
                  />
                </Tooltip>
              )}
            </>
          ) : null}
        </Flex>
      </Flex>

      <Flex gap={4} align="end">
        <CustomParagraph
          text={value || "---"}
          fontSize={32}
          fontWeight={700}
          lineHeight={"32px"}
          marginBottom={0}
          color={"#000"}
        />

        <Flex gap={8} align="center">
          <span style={{ display: "flex", alignItems: "center" }}>

            <CustomParagraph
              text={getFormattedChange(change)}
              fontSize={12}
              fontWeight={400}
              lineHeight={"20px"}
              marginBottom={0}
              whiteSpace={"nowrap"}
              color={getChangeColor(change)}
            />
          </span>

         {change !== '---' &&  <CustomParagraph
            text={fromDate || ""}
            fontSize={12}
            fontWeight={400}
            lineHeight={"20px"}
            marginBottom={0}
            color={"#5E5E5E"}
          />}
        </Flex>
      </Flex>
    </>
  );
};

export default AnalyticsChartData;
